<div class="bom-comment">
  <div class="bom-comment-content">
    <gc-text [variant]="'informationBold'" [textColor]="'critical'">{{
      'installationReportV2.orderOverviewTab.comment' | translate
    }}</gc-text>
    <gc-text [variant]="'information'">{{ comment() }}</gc-text>
  </div>
  <div class="bom-comment-meta">
    @if (updatedBy()) {
      <gc-text [variant]="'information'" [textColor]="'secondary'">
        {{ 'buildingPageModal.sectionNotApplicable.by' | translate }}
        {{ updatedBy() }}
      </gc-text>
    }
    @if (updatedAt()) {
      <gc-text [variant]="'information'" [textColor]="'secondary'">{{
        updatedAt() | date: 'yyyy-MM-dd'
      }}</gc-text>
    }
  </div>
</div>
